import React from "react";
import { useQuery } from "@apollo/client";
import { GET_GRAPHIC_PACKING_LIST } from "graphql/query/graphic-packing-gql";
import { GET_GRAPHIC_STANDS_CURSOR } from "graphql/query/graphic-stand-gql";
import { PageWrapDefault } from "components/layout";
import { useActiveMenuItem } from "components/use-hooks";
import GraphicPackingRoute from 'components/routes/graphic-packing/graphic-packing-route';
import GraphicPacking from 'components/graphic-packing';
import { Localize } from "components/service";


const basePath = GraphicPacking.Const.basePath;

const GraphicPackingPage = ({ match, history }) => {
    useActiveMenuItem([ "graphic-packings" ], [ "graphic-packings" ]);

    const graphicPackingID = match ? match.params.graphicPackingID : null;
    const isCreate = graphicPackingID === 'create';

    const { data, loading } = useQuery(GET_GRAPHIC_PACKING_LIST, {
        skip: isCreate,
        variables: {
            id: graphicPackingID
        },
        fetchPolicy: 'cache-and-network',
    });

    const { data: graphicStandsData } = useQuery(GET_GRAPHIC_STANDS_CURSOR, {
        skip: isCreate || !graphicPackingID,
        variables: {
            first: 1,
            where: {
                column: 'GRAPHIC_LIST_ID',
                value: graphicPackingID
            }
        },
        fetchPolicy: 'cache-and-network',
    });

    const graphicPacking = data?.graphicList;
    const hasGraphicStands = graphicStandsData?.graphicStandsCursor?.pageInfo?.total > 0;

    const pageNavbar = graphicPacking && [
        {
            label: <Localize>NAVBAR_PAGES.Label_Overview</Localize>,
            path: "overview"
        },
        {
            label: <Localize>NAVBAR_PAGES.Label_GraphicChoises</Localize>,
            path: "stands"
        },
        hasGraphicStands ? {
            label: <Localize>NAVBAR_PAGES.Label_GraphicPackedList</Localize>,
            path: "packed-list"
        } : null,
    ].filter(Boolean);


    return (
        <PageWrapDefault
            className="page-graphic-packing"
            loading={ loading }
            title={ isCreate ? <Localize>PAGES.Title_CreateExhibitionPacking</Localize> : !loading && graphicPacking ? graphicPacking.title : 'Page 404' }
            dataExist={ isCreate ? true : !loading && graphicPacking }
            pageNavbar={ graphicPacking ? pageNavbar : false }
            staticPath={ graphicPacking ? `${ basePath }/${ graphicPacking.id }` : undefined }
        >
            <GraphicPackingRoute
                graphicPacking={ graphicPacking }
                loading={ loading }
                isCreate={ isCreate }
                history={ history }
            />
        </PageWrapDefault>
    );
};

export default GraphicPackingPage;